import { SEARCH_API_PATHS } from '../constants/search'
import { apiRequest } from './client'
import type { ApiProductSearchResponse, ProductSearchParams } from './types'

export function searchProducts(
  params: ProductSearchParams = {},
): Promise<ApiProductSearchResponse> {
  return apiRequest<ApiProductSearchResponse>(SEARCH_API_PATHS.products, {
    query: params,
  })
}
